enum DesignNotificationEvent {
    // Drawings
    DrawingStatusesChange = 1, // Смена статусов чертежей
    DrawingDataRolesAssignment, // Присвоение ролей в данных по чертежу - 2
    DrawingAnnotationsCreation, // Создание замечаний - 3
    DrawingAnnotationsChange, // Изменение замечаний  - 4
    DrawingAnnotationsByGroupMove, // Перемещение замечаний по группам - 5
    DrawingAnnotationsFulfillment, // Выполнение замечаний - 6
    DrawingAnnotationsNewMessage, // Новые сообщения в замечаниях - 7

    // Tasks
    TasksAssignment, // Назначение задач - 8
    TasksDataChange, // Редактирование данных и описания задач - 9
    TasksStatusChange, // Изменение статусов задач - 10
    TasksNewMessages, // Новые сообщения в задачах - 11
    TasksFulfillment, // Выполнение задач исполнителями - 12
    TasksDeadlineChange, // Продление сроков задач - 13

    TasksCreate, // Создание задачи - 14
    DrawingAcceptReturnRequest, // Принятие запроса на возврат чертежа в работу - 15
    DrawingRejectReturnRequest, // Отклонение запроса на возврат чертежа в работу  - 16
    DrawingCreateReturnRequest, // Создание запроса на возврат чертежа в работу  - 17

    Logs, // logs (empty) - 18

    DrawingExpirationDate, // Истекших сроки проверки чертежа/устранения замечаний - 19
    DrawingDelete, // удаление чертежа - 20
    TasksDeleteAuthorTask, // 21
}

export enum PrescriptionNotificationEvent {
    CreatePrescription = 1, // Создание предписания
    ChangePrescriptionStatus, // Изменение статуса предписания
    ChangeListExecutors, // Изменение списка исполнителей
    ChangeDeadline, // Изменение крайнего срока
    ChangePrescriptionInfo, // Изменение информации по предписаниям
    SendPrescriptionOverdue, // Отправка уведомлений по просроченным предписаниям
    ChangeRemarkStatus, // Изменение статуса по замечаниям
    ChangePrescriptionAct, // Изменения акта по предписанию
}

export enum EstimateNotificationEvent {
    ChangeEstimateStatus = 1, // Изменение статуса
    SendChatMessage, // Отправка сообщения в чате
}

export default DesignNotificationEvent;
